import React, { useState } from 'react';
import { RiAddBoxFill } from 'react-icons/ri';
import { AiFillDelete } from 'react-icons/ai';
import { Spin, Card, Col, Row, Input, message, Table } from 'antd';
import { FaEdit } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import { blogdelete, getBlogs } from '../../../utils/API';

interface SliderData {
  _id: number;
  title: string;
  description: string;
  active: boolean;
}

const IndexBlog: React.FC = () => {
  const [slidersData, setSlidersData] = useState<SliderData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchText, setSearchText] = useState<string>('');
  const navigate = useNavigate();

  const fetchSizeData = () => {
    setLoading(true);
    getBlogs()
      .then((response: any) => {
        setSlidersData(response.blogs);
      })
      .catch(() => {
        message.error('Network error. Please try again.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    fetchSizeData();
  }, []);

  const handleEditRedirect = (record: SliderData) => {
    navigate(`/backend/blog/${record._id}/edit`);
  };

  const handleDelete = (record: SliderData) => {
    blogdelete(record._id)
      .then((response: any) => {
        if (response.status === 200) {
          message.success(response.data.message);
          fetchSizeData();
        } else {
          message.error('Something went wrong');
        }
      })
      .catch((error: any) => {
        message.error(error.response.data.message);
      });
  };

  const filteredData = slidersData.filter((blog) =>
    blog.title.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: (
        <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>
          Title
        </div>
      ),
      dataIndex: 'title',
      key: 'title',
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: (
        <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>
          Description
        </div>
      ),
      dataIndex: 'description',
      key: 'description',
      render: (text: string) => (
        <span title={text}>
          {text.length > 20 ? `${text.substring(0, 20)}...` : text}
        </span>
      ),
    },
    {
      title: (
        <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#a6a6a6' }}>
          Action
        </div>
      ),
      dataIndex: 'action',
      key: 'action',
      render: (_: any, record: SliderData) => (
        <div className='d-flex'>
          <FaEdit className='editMenuIcon' onClick={() => handleEditRedirect(record)} />
          <AiFillDelete className='editMenuIcon' onClick={() => handleDelete(record)} />
        </div>
      ),
    },
  ];

  return (
    <>
      <Row className="m-2" align={"middle"}>
        <Col
          xs={24}
          sm={24}
          md={9}
          xl={6}
          xxl={6}
          className="d-flex justify-content-start font-bold"
        >
          <h2 className="text-2xl">Blogs</h2>
        </Col>
        <Col xs={24} sm={24} md={24} xl={18} xxl={18} className="">
          <Row gutter={16} className="float-center xs:m-2">
            <Col xs={0} sm={0} md={0} xl={7} xxl={7}>
            </Col>
            <Col xs={24} sm={24} md={10} xl={12} xxl={12} className=''>
              <Input
                prefix={<SearchOutlined style={{ color: "#a6a6a6" }} />}
                size="large"
                className="float-end w-75"
                placeholder="Search..."
                allowClear
                autoComplete='off'
                onChange={(e) => setSearchText(e.target.value)}
              />
            </Col>

            <Col xs={24} sm={24} md={6} xl={5} xxl={5} style={{ paddingRight: '-8px !important' }}>
              <Link to={"/backend/blog/add"} >
                <button className="d-flex justify-content-center align-items-center w-100 border btn-brand">
                  <RiAddBoxFill style={{ fontSize: "15px" }} />
                  <div className="ms-2">Add Blogs</div>
                </button>
              </Link>
            </Col>

          </Row>
        </Col>
      </Row>
      <Row>
        <Col
          style={{ backgroundColor: "#ffffff", borderRadius: "12px" }}
          xs={24}
          sm={24}
          md={24}
          xl={24}
          xxl={24}
        >
          <Card className="bg-white border " style={{ borderRadius: "12px" }}>
            <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
              <Spin spinning={loading}>
                <div style={{ overflowX: "auto" }}>
                  <Table
                    columns={columns}
                    dataSource={filteredData || []}
                    rowKey="_id"
                    scroll={{ x: true }}
                  />
                </div>
              </Spin>
            </Col>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default IndexBlog;
